// Utils
import { useUserAccessList } from "../../utils/UserAccessList";
// MUI
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

export const UserAccess = ({ userCard }) => {
  const access = useUserAccessList(userCard);
  const userAdmin = userCard.adminid;
  // const adminList = userCard.admins;
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 800,
        // px:5,
        mt: 2,
      }}
    >
      <Typography
        sx={{
          marginBottom: "16px",
        }}
      >
        Access Level: {userCard.role}
      </Typography>
      {/* {userCard.allowcheckout !== "true" && (
        <Typography sx={{ marginBottom: "16px" }}>
          Your approval admin is {userAdmin}
        </Typography>
      )} */}
      <List
        // sx={{
        //   mt: 2,
        // }}
        sx={{
          mt: 2,
          display: "flex",
          flexFlow: "column wrap",
          height: { md: 750 },
          overflow: "auto",
        }}
      >
        {Object.entries(access).map(([key, value]) => (
          <Box key={key}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar
                  alt={key}
                  sx={{
                    bgcolor:
                      value.value === "true" ? "primary.main" : "disabled.main",
                  }}
                >
                  {value.icon}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={value.title}
                secondary={
                  <>
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        display: "inline",
                      }}
                    >
                      {value.desc}
                    </Typography>
                  </>
                }
              />
            </ListItem>

            <Divider variant="inset" component="li" />
          </Box>
        ))}
      </List>
    </Box>
  );
};
